<template>
	<nav class="customClassNav position-relative bg-white d-flex flex-row">
		<div class="divLogoTCS d-flex flex-row justify-content-center">
			<button class="burger-menu" @click="menuButtonClicked">
				<MenuIcon color="white" />
			</button>
			<div class="divTextTCSMMI d-flex flex-row justify-content-center align-items-center">
				<h1 class="textoLogo m-0">TCS <span class="textMMI">| MMI</span></h1>
			</div>
		</div>

		<div class=" divMonitor d-flex flex-row p-0 align-items-center">
			<button class="returnArrow " @click="$router.back()">
				<ArrowLeftIcon color="var(--bg-secundario)" />
			</button>
			<h2 class="textMonitor m-0 ">Monitor </h2>
			<h2 class="textDashboard m-0 px-3">|</h2>
			<h2 class="textDashboard m-0">{{ tituloPrincipal }}</h2>
		</div>
		<div class="divTurno ml-auto d-flex flex-row align-items-center">
			<div class="d-flex align-items-center" title="Turno Atual"
				v-b-popover.hover.bottom.html="turnoAtualTemplate" data-placement="bottom" data-popover>
				<ClockIcon class="icon-nav " color="var(--texto-secundario)" />
			</div>



			<button class="btn-menu" @click.stop="openMenuModulos()">
				<template>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="var(--texto-secundario)">
						<path fill="#696969"
							d="M15.984 20.016v-4.031h4.031v4.031h-4.031zM15.984 14.016v-4.031h4.031v4.031h-4.031zM9.984 8.016v-4.031h4.031v4.031h-4.031zM15.984 3.984h4.031v4.031h-4.031v-4.031zM9.984 14.016v-4.031h4.031v4.031h-4.031zM3.984 14.016v-4.031h4.031v4.031h-4.031zM3.984 20.016v-4.031h4.031v4.031h-4.031zM9.984 20.016v-4.031h4.031v4.031h-4.031zM3.984 8.016v-4.031h4.031v4.031h-4.031z">
						</path>
					</svg>
				</template>
			</button>


			<div v-if="isOpen" class="menu-modulos" ref="dropdown">
				<div v-if="modulosError" class="menu-erro">
					{{ modulosError }}
				</div>
				<div class="menu-links" v-else v-for="modulo in modulos" :key="modulo.nome">
					<a :href="modulo.url">
						{{ modulo.nome }}
					</a>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>

	import { TurnosService } from "../services/turnos";
	import { getModulesURL } from "../services/modules";

	const turnosService = new TurnosService();

	export default {
		data () {
			return {
				modulos: [],
				modulosError: null,
				tituloPrincipal: "Dashboard",
				isOpen: false,
				turnoAtualTemplate: ""
			};
		},

		watch: {
			$route: {
				immediate: true,
				handler (route) {
					this.tituloPrincipal = route.meta.title ?? "Dashboard";
				}
			}
		},

		methods: {
			menuButtonClicked () {
				this.$emit("menu-button-click");

			},

			openMenuModulos () {
				this.isOpen = !this.isOpen;

				if (this.isOpen) {
					document.addEventListener("click", this.closeOutside);
				} else {
					document.removeEventListener("click", this.closeOutside);
				}

			},

			closeOutside (event) {
				const dropdown = this.$refs.dropdown;

				if (dropdown && !dropdown.contains(event.target)) {
					this.isOpen = false;

					document.removeEventListener("click", this.closeOutside);
				}
			}
		},

		beforeDestroy () {
			document.removeEventListener("click", this.closeOutside);
		},


		async mounted () {
			const { data, error } = await getModulesURL();
			this.modulos = data.filter(modulo => modulo.possuiFrontend);
			this.modulosError = error;

			try {
				const turnoAtualPop = await turnosService.obterTurnoAtual();
				this.turnoAtualTemplate = `
					Data do turno atual: ${turnoAtualPop.dataTurno} </br>
					Turno atual: ${turnoAtualPop.turno}º </br>
					Período: ${turnoAtualPop.dataInicio} ${turnoAtualPop.inicio} - ${turnoAtualPop.dataFim} ${turnoAtualPop.fim} `;
				const dataTurnoSeparada = turnoAtualPop.dataTurno.split("/");
				const dataTurnoSistema = dataTurnoSeparada[2] + "-" + dataTurnoSeparada[1] + "-" + dataTurnoSeparada[0];
				localStorage.setItem("dataTurnoSistema", dataTurnoSistema);

			} catch (error) {
				console.error("Erro ao buscar turno atual:", error);
				this.turnoAtualTemplate = "Erro ao carregar informações do turno";
			}
		}
	};
</script>


<style scoped>
.customClassNav {
	height: 64px;

	margin: 0;
	padding: 0;
	background-color: var(--bg-primario);
	box-shadow: 0 10px 15px -10px rgba(0, 0, 0, 0.3);

}

.divLogoTCS {
	height: 64px;
	width: 211px;
	background-color: var(--bg-secundario);
	gap: 1em;
	padding-left: 0;

}

.textoLogo {
	color: var(--texto-primario);
	font-family: var(--fonte-primaria);
	font-weight: 450;
	font-size: 40px;
	line-height: 1;
}

.textMMI {
	color: var(--texto-primario);
	font-family: var(--fonte-semi-bold);
	font-size: 33px;
	font-weight: 300;
	line-height: 1;
}

.burger-menu {
	background: transparent;
	border: none;
	cursor: pointer;
	padding-bottom: 5px;
	margin-left: -10px;
	width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.burger-menu svg {
	fill: var(--bg-primario);
	transition: fill 0.3s ease;
}

.burger-menu:hover svg {
	fill: var(--texto-secundario);
}

.divMonitor {
	gap: 0.5em;
	display: flex;
}

.returnArrow {
	border: none;
	height: 64px;
	width: 50px;
	background-color: transparent;
	transition: all 0.3s ease;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.returnArrow svg {
	transition: transform 0.3s ease;
}

.returnArrow svg path {
	fill: var(--bg-secundario);
	transition: fill 0.3s ease;
}

.returnArrow:hover {
	background-color: var(--texto-secundario);
	width: 64px;
}

.returnArrow:hover svg path {
	fill: var(--bg-primario);
}

.textMonitor {
	color: var(--bg-secundario);
	font-family: var(--fonte-semi-bold);
	font-size: 32px;
	line-height: 1;
}

.textDashboard {
	color: var(--texto-secundario);
	font-family: var(--fonte-light);
	font-size: 28px;
	line-height: 1;
}

.divTurno {
	gap: 1em;
	padding: 1em;
}

.icon-nav {
	width: 21px;
	height: 21px;
}

.btn-menu {
	border: none;
	background-color: transparent;
}


.menu-modulos {
	display: block;
	position: absolute;
	background-color: rgb(255, 255, 255);
	top: 67px;
	right: 20px;
	z-index: 10;
	width: 120px;
	border-radius: 8px;
	border: 1px solid #bdbdbd;
	overflow: hidden;
}


.menu-links {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	font-family: var(--fonte-semi-bold);
}

.menu-links>a {
	display: flex;
	justify-content: center;
	color: var(--texto-secundario);
	text-decoration: none;
	padding: 8px;
	padding-top: 12px;
	padding-bottom: 12px;
	width: 100%;
	height: 100%;
	border-bottom: 1px solid #bdbdbd;
}

.menu-links :hover {
	background-color: #6dcff6;
	color: white;
	cursor: pointer;
}

.menu-erro {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	font-family: var(--fonte-semi-bold);
	color: var(--texto-secundario);
	padding: 8px;
}
</style>